var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
export var StyledButton = styled.button(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  &:hover {\n    opacity: 0.7;\n  }\n\n  &:disabled {\n    opacity: 0.7;\n  }\n\n  border-radius: 5px;\n  background-color: black;\n  color: #f8f8f8;\n  cursor: pointer;\n  text-align: center;\n  border: unset;\n\n  width: ",
      ";\n  height: ",
      ";\n  margin-top: ",
      ";\n  padding: ",
      ";\n",
    ])),
  function (_ref) {
    var width = _ref.width;
    return width ? width : "100%";
  },
  function (_ref2) {
    var height = _ref2.height;
    return height ? height : "56px";
  },
  function (_ref3) {
    var marginTop = _ref3.marginTop;
    return marginTop ? marginTop : "0";
  },
  function (_ref4) {
    var pad = _ref4.pad;
    return pad ? pad : "0";
  }
);
